import React, { ReactElement } from 'react'
import { OmitNative } from 'react-router'
import { Route, RouteProps } from 'react-router-dom'
import { Path } from 'typescript'

/**
 * Uplne normalni react-router-dom Route az na to,
 * ze ma parametr 'element', ktery nahrazuje 'component'
 * v novejsich verzich react-router-dom.
 *
 * Pozn.:
 * - component je predpis (typu React.ComponentType)
 * - element je immutable 'virtualni instance' v ramci React
 *
 * Vice viz:
 * - https://stackoverflow.com/questions/30971395/difference-between-react-component-and-react-element
 * - https://reactjs.org/blog/2015/12/18/react-components-elements-and-instances.html
 *
 * - https://www.w3schools.io/learn/react-typescript-functional-components/
 */

export type RouteNextProps<T extends {} = {}, Path extends string = string> = {
  element?: React.ReactElement
} & RouteProps<Path> &
  OmitNative<T, keyof RouteProps>

function RouteNextVersion(props: RouteNextProps) {
  //return <Route {...props} render={(routingRenderProps) => props.element} />
  if (props.element != null) {
    return <Route {...props}>{props.element}</Route>
  } else {
    return <Route {...props} />
  }
}

/*
function RouteNextVersion(element: React.ReactElement, { ...rest }) {
  return <Route {...rest} render={(props) => element} />
}
*/
/*
function PublicRoute( element: ReactElement, { ...rest }) {
  return <Route {...rest} element={}/>
}*/

export default RouteNextVersion
